const appInfo = {
    title: 'Hermesx 2024 AC/DC Edition'
};
export default appInfo;

